<template>
  <label
    :tabindex="!disabled ? 0 : -1"
    :class="{ disabled }"
    @keydown.enter="!disabled && $emit('input', !value)"
    @keydown.space.prevent="!disabled && $emit('input', !value)"
  >
    <div class="toggle pdg- mrgr-" :class="{ activated: value }">
      <div class="shadow">
        <Icon v-show="value" id="check" class="text-primary" />
      </div>
      <input
        type="checkbox"
        :disabled="disabled"
        @change="!disabled && $emit('input', !value)"
      />
    </div>
    <span :style="{ width: labelWidth }">
      {{ value ? label : labelDisabled }}
    </span>
  </label>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    labelDisabled: { type: String, required: true },
    value: { type: Boolean, required: true },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    labelWidth() {
      return `${Math.max(this.label.length, this.labelDisabled.length)}ch`;
    },
  },
};
</script>

<style lang="scss" scoped>
.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.toggle {
  border-radius: 2em;
  background-color: $alt-300;
  width: 4em;
  height: 2em;
  position: relative;

  > div {
    height: 2em;
    width: 2em;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    background-color: $alt-600;
    transition: left 0.2s ease-in-out;
    position: absolute;
    top: 0;
    left: 0;

    > .icon {
      top: 0;
    }
  }

  > input {
    display: none;
  }

  &.activated {
    background-color: $brand-600;

    > div {
      left: calc(100% - 2em);
      background-color: $brand-50;
    }
  }
}
</style>
